module.exports = __webpack_public_path__ + "bce072056220cbe635377d77fcc21ca8.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/sec-5/reviews-section-5/review-5.jpg
// module id = ./app/containers/StaticPage/ComeBack/assets/sec-5/reviews-section-5/review-5.jpg
// module chunks = 40